import { Link } from "react-router-dom";
import { HeartHandshake, LogIn } from "lucide-react";

export function LandingHeader() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-bg/80 border-b border-brd">
      <div className="max-w-6xl mx-auto px-5 py-3.5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-turq-900 flex items-center justify-center shadow-lg shadow-turq-900/25">
            <HeartHandshake className="w-6 h-6 text-white" />
          </div>
          <span className="w-11 h-11 rounded-2xl bg-white border border-brd flex items-center justify-center overflow-hidden shadow-md shrink-0">
            <img src="/assets/moe-logo.png" alt="شعار وزارة التعليم" data-testid="moe-logo-header" className="w-8 h-8 object-contain"
              onError={(e) => { e.currentTarget.style.display = "none"; }} />
          </span>
          <div>
            <div className="font-head font-black text-base leading-tight">سجل عطاء وأثر تعليم الشرقية</div>
            <div className="text-[10.5px] text-mutext">«نرصد العطاء … ونقيس الأثر»</div>
          </div>
        </div>
        <nav className="flex items-center gap-2 sm:gap-5 text-sm">
          <a href="#honor" data-testid="nav-public-honor-link" className="hidden sm:inline text-mutext hover:text-ink font-bold transition-colors">لوحة الشرف</a>
          <a href="#values" data-testid="nav-public-values-link" className="hidden sm:inline text-mutext hover:text-ink font-bold transition-colors">قيمنا</a>
          <a href="#stories" data-testid="nav-public-stories-link" className="hidden sm:inline text-mutext hover:text-ink font-bold transition-colors">قصص الأثر</a>
          <Link to="/login" data-testid="nav-login-btn"
            className="rounded-full bg-coral-600 hover:bg-coral-900 text-white text-xs font-bold px-5 py-2.5 flex items-center gap-1.5 transition-colors shadow-lg shadow-coral-600/25">
            <LogIn className="w-3.5 h-3.5" /> دخول
          </Link>
        </nav>
      </div>
    </header>
  );
}
